import PropTypes from 'prop-types'

import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, DashboardModule, DashboardModuleListItem, Text,
} from '@domain-group/suit-theme'

import { isValidPrice } from '@domain-group/javascript-utils'

import useCurrentUser from '@hooks/useCurrentUser'
import usePricingPlans from '@hooks/usePricingPlans'

const PricingPlan = (props) => {
  const { isBrandUser } = useCurrentUser()

  const { agencyPayload } = props
  const {
    agency,
    callbacks: {
      manageAgencyPricingPlan,
    },
    loading: loadingAgency,
    pricingPlan,
  } = agencyPayload

  const {
    campaign_fee,
    campaign_fee_cap,
    pricing_plan_id,
  } = agency

  const { loading: loadingPricingPlans } = usePricingPlans({ performHttpRequests: !isBrandUser })

  const { title: pricingPlanTitle } = pricingPlan || {}

  const loading = loadingAgency || loadingPricingPlans

  const hasCampaignFee = isValidPrice(campaign_fee)
  const hasCampaignFeeCap = isValidPrice(campaign_fee_cap)
  const hasPricing = hasCampaignFee || hasCampaignFeeCap || !!pricing_plan_id

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Pricing Plan"
    >
      {!loading && hasPricing && (
        <DashboardModuleListItem
          isChecked={!!pricing_plan_id}
          onClick={() => manageAgencyPricingPlan()}
          showCheckbox
          title={pricingPlanTitle || 'Pricing Plan Not Set'}
        >
          <Box alignItems="flex-end" flexDirection="column" lineHeight="1.3">
            {hasCampaignFee && (
              <Text color="bodyFontLightColor" fontSize="xsmall">
                ${campaign_fee} Per Campaign
              </Text>
            )}

            {hasCampaignFeeCap && (
              <Text color="bodyFontLightColor" fontSize="xsmall">
                ${campaign_fee_cap} Fee Cap
              </Text>
            )}
          </Box>
        </DashboardModuleListItem>
      )}

      {!loading && !hasPricing && (
        <DashboardModule.Footer boxProps={{ borderTop: 'none' }}>
          <Text
            color="bodyFontLightColor"
            display={['none', 'flex']}
            fontSize="small"
            variant="ellipsis"
            maxWidth="60%"
          >
            Pricing Not Set
          </Text>

          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => manageAgencyPricingPlan()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Pricing
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      )}
    </DashboardModule>
  )
}

PricingPlan.propTypes = {
  agencyPayload: PropTypes.object,
}

export default PricingPlan
